export const grants = [
        {
            title: 'NSERC Alliance: "Scalable and Secure Edge AI Solutions for Large Language Models and Visual Question Answering", PI Awarded.',
            date: '2025-2029',
            text: '$386,664'
        },
        {
            title: 'Mitacs Accelerate (PI, Total: $135,000)',
            date: '2025-2026',
            text: 'Integration of Generative AI into AI-native services in next generation networks'
        },
        {
            title: 'Ontario Research Fund-Research Excellence (ORF-RE) (PI, Total: $999,985)',
            date: '2025-2029',
            text: 'SITE-CAV: Secure, Intelligent and Trustworthy Ecosystems for Connected and Autonomous Vehicles (SITE-CAV)'
        },
        {
            title: 'Mitacs Accelerate (PI, Total: $165,000)',
            date: '2024-2026',
            text: 'Traffic Estimation and Stable Resource Allocation Using Distributed Machine Learning'
        },
        {
            title: 'NSERC DISCOVERY (PI, Total: $265,000)',
            date: '2024-2029',
            text: 'Building Reliable and Secure Networks Driven by the Frontiers of Artificial Intelligence for Smart and Connected Critical Infrastructures'
        },
        {
            title: 'Mitacs Accelerate (PI, Total: $90,000)',
            date: '2024-2025',
            text: 'Improving Safety of The Intended Functionality (SOTIF) Analysis for Autonomous Vehicles'
        },
        {
            title: 'Mitacs Accelerate (PI, Total: $90,000)',
            date: '2024-2025',
            text: 'Machine Learning-Driven Decision Support for Autonomous Services in Airport Operations'
        },
        {
            title: 'NSERC Collaborative Research and Training Experience (CREATE), PI, Total: $1,650,000)',
            date: '2023-2029',
            text: 'CREATE Program for Training and Research in Autonomous Vehicles for Reliable Services in the Air and on Land (TRAVERSAL)'
        },
        {
            title: 'NSERC Alliance Mitacs Accelerate (PI, Awarded, Total: $135,000)',
            date: '2022-2024',
            text: 'Intelligent Strategies for Optimal Virtual Network Function Placement in 5G Core'
        },
        {
            title: 'UTFORSK-Norway [lead institution: Univ. of Agder] (Co-PI & uOttawa Project Coordinator, Total Budget: 3M NOK ~ $400,000 CAD)',
            date: '2023-2026',
            text: 'Elevating the Quality of Education in ICT towards 2030 through Multilateral Collaborations (EQEI)'
        },
        {
            title: 'Department of National Defence –Innovation for National Defence and Security (IDEaS) (PI, Total: $1,486,375 )',
            date: '2022-2025',
            text: 'Autonomous, Reliable, Scalable and Secure Resource Management in Multi-level 5G edge'
        },
        {
            title: 'Department of National Defence –Innovation for National Defence and Security (IDEaS) (PI, Total: $1,495,062 )',
            date: '2022-2025',
            text: 'AI-Driven Situational-Aware Security and Performance Assurance for 5G-Enabled Critical Infrastructures'
        },
        {
            title: 'Mitacs Accelerate (PI Total: $40,000)',
            date: '2022-2023',
            text: 'An End User-Centric Study of Autonomous Technology Adoption in Controlled Environments'
        },
        {
            title: 'Mitacs Business Strategy Internship (BSI) (Total: 40,000, PI)',
            date: '2022',
            text: 'Project Title: Food and Beverage Golf Course Drone Delivery'
        },
        {
            title: 'Ontario Centre for Innovation - Voucher for Innovation Productivity (VIP) (PI, Total: $156,666)',
            date: '2022-2023',
            text: 'Project Title: Deep Learning-Driven Integrated driver distraction detection system from multi-modal vehicular sensor data'
        },
        {
            title: 'NSERC-Ontario Centre of Innovation VIP Alliance (Awarded: $90,000 PI, $75K In Cash)',
            date: '2021-2022',
            text: 'Project Title: Security by Design via Radio Fingerprinting for Autonomous Vehicle (AV) Network'
        },
        {
            title: 'Mitacs Accelerate Awarded ($225,000; co-PI share 50%)',
            date: '2021-2023',
            text: 'Project Title: Machine Learning-Enhanced Anomaly Detection and Performance Optimization for Enterprise WiFi Networks'
        },
        {
            title: 'Canada Foundation for Innovation (CFI)- John R. Evans Leaders Fund (PI)+ Ontario Research Fund-Research Infrastructure  (Awarded: $650,574)',
            date: '2020-2024',
            text: 'Project Title: AI-Backed Internet of Vehicles Laboratory: An Open Access Innovation Facility'
        },
        {
            title: 'NSERC Alliance (Total Amount: $50,000, PI)',
            date: '2020-2021',
            text: 'Project Title: Artificial Intelligence-Based Decision Support System for COVID-19 Mobile Assessments and Optimal Supply Services During the Pandemic'
        },
        {
            title: 'Ontario Centres of Excellence (OCE) - 5G (ENCQOR) Academic Technology Development Program (Awarded, Total Amount: $150,000, PI)',
            date: '2020-2022',
            text: 'Project Title: Machine Learning-based Firewall-less Security Automation for the Network Edge'
        },
        {
            title: 'MITACS Elevate (Awarded, Total Amount: $120,000, PI)',
            date: '2020-2022',
            text: 'Project title: Meta-information Extraction from Large-scale Streaming News for Entity-level Media Intelligence and Reporting'
        },
        {
            title: 'MITACS Accelerate (Cluster-Size; Awarded: $270,000 CAD in cash, PI)',
            date: '2019-2022',
            text: 'Project Title: AI-Based Automated Methodologies for Supply Chains: High Precision Tabular Detection and Semantic Modeling of E-Components'
        },
        {
            title: 'Ontario Centres of Excellence-OCE AVIN TIP (Awarded $40,000CAD total $30,000CAD in cash, PI)',
            date: '2019-2020',
            text: 'Project Title: Vehicular Sensor Fusion for Detection and Characterization of Significant Events'
        },
        {
            title: 'Ontario Centres of Excellence-OCE VIP 1 (Awarded $39,999CAD total $24,999CAD in cash, PI)',
            date: '2019',
            text: 'Project Title: Fine-grained continuous authentication accounting for multiple risk context factors'
        },
        {
            title: 'NSERC ENGAGE (Awarded $25,000 CAD, PI)',
            date: '2018',
            text: 'Project Title: Semantic Modelling and Machine Learning Analysis of a Billion+ Electronic Components Products to Support Supply Chain Optimization'
        },
        {
            title: 'Ontario Centres of Excellence-OCE VIP1 (Awarded $39,983 CAD total, $24,983CAD in cash, PI)',
            date: '2018',
            text: 'Project Title: Semantic Modelling and Machine Learning Analysis of a Billion+ Electronic Components Products to Support Supply Chain Optimization'
        },
        {
            title: 'NSERC DISCOVERY  (Awarded $125,000 CAD in total, PI)',
            date: '2017-2022',
            text: 'Project Title: Mobile social network analytics and mobile edge solutions for trustworthy and reliable urban sensing'
        },
        {
            title: 'Visiting Researcher Program- OVPR (Awarded, $6,000 CAD, PI)',
            date: '2018',
            text: 'Project Title: Empowering Smart Mobile Devices for Real-time Health Analytics'
        },
        {
            title: 'NSF US-Ignite: (Awarded, $750,000CAD;  co-PI share: $137,788 CAD Subawarded to the University of Ottawa)',
            date: '2017-2021',
            text: 'Project Title: An Integrated Reconfigurable Control and Self-Organizing Communication Framework for Advanced Community Resilience Microgrids'
        },
        {
            title: 'NSF-CRII: Secure Trustworthy Cyberspace Program (Awarded $225,000 CAD,  PI)',
            date: '2015-2017',
            text: 'Project title: CRII: SaTC: Energy efficient participatory data collection and Context-Aware Incentives for Trustworthy Crowdsensing via Mobile Social Networks'
        },
        {
            title: 'CITeR: NSF-I/UCRC Cooperative Research Center (PI, Awarded $50,000 CAD)',
            date: '2015-2016',
            text: 'Project Title: Context-aware Anomaly Detection in Internet of Biometric Things'
        },
        {
            title: 'Qualcomm Inc., (PI, Awarded $20,000.00 )',
            date: '2015-2017',
            text: 'Project Title: Wireless Internet of Things Lab for Sensor Networks, Localization, and Mobile Computing at Clarkson University'
        },
        {
            title: 'University of Ottawa Startup Grant',
            date: '2016- Present',
            text: 'Project Title: Large scale sensing systems for smart cities'
        },
        {
            title: 'Clarkson University Startup Grant',
            date: '2014-2016',
            text: 'Project Title: Clarkson University Research Startup'
        },
        {
            title: 'Postdoctoral Research fellowship',
            date: '2009-2014',
            text: 'Awarded at University of Ottawa by WiSense project at School of EECS'
        },
        {
            title: 'PhD Research Grant (funded PhD thesis study at the University of Ottawa)',
            date: '2007-2008',
            text: 'TUBITAK-Scientific and Technological Research Council of Turkey'
        },
        
        

    ];